import { Card, FormControl, FormHelperText, FormLabel, Grid, GridItem, Input } from '@chakra-ui/react';
import MapLocation from '../../../../components/map';


const DetailCellRenderer = (rowData: any) => {

    const rowDetail = rowData.rowData;

    return (


        <Grid templateColumns="repeat(4, 1fr)" gap="3">
            <GridItem colSpan={2} padding={2} >
                <FormControl padding={1}>
                    <FormLabel>Site Reference</FormLabel>
                    <Input defaultValue={rowDetail?.reference!} />
                </FormControl>

                <FormControl padding={1}>                    <FormLabel>Site Address</FormLabel>
                    <Input defaultValue={rowDetail?.address!} />
                </FormControl>

                <FormControl padding={1}>                    <FormLabel>Site Type</FormLabel>
                    <Input defaultValue={rowDetail?.type!} />
                </FormControl>

                <FormControl padding={1}>                    <FormLabel>Site Metadata</FormLabel>
                    <Input defaultValue={rowDetail?.meta!} />
                </FormControl>


            </GridItem>

            <GridItem colSpan={2}>
                <Card margin={1} variant={"elevated"}>

                    <MapLocation lng={rowDetail.lng} lat={rowDetail.lat} marker={rowDetail?.description!} />
                </Card>

            </GridItem>
        </Grid>

    );
}

export default DetailCellRenderer;